enum Size {
  EXTRA_SMALL = "xs",
  MEDIUM = "md",
  SMALL = "sm",
  LARGE = "lg",
  EXTRA_LARGE = "xl",
  XXL = "xxl",
  FULL_WIDTH = "block",
  PREVIEW = "preview"
}

export default Size;
